<template>
  <div class="container">
    <Navbar />
    <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link tag="li" :to="{ name: 'Home' }">
            <a>Home</a>
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            tag="li"
            :to="{
              name: 'AccessUsersToOnlineOrders',
              params: { restId: restId, id: restNum },
            }"
          >
            <a>{{ capitalizeFisrtLetterOfEachWord(userName) }}</a>
          </router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Custom Reciept
        </li>
      </ol>
    </nav>
    <div class="add-new-restaurant-page">
      <!-- Add new restaurant -->
      <p>{{ userAddress }}</p>
      <form method="post" action="#" enctype="multipart/form-data">
        <div class="row g-3 align-items-center mb-3">
          <div class="col-auto d-block mx-auto">
            <h3>Customize your Reciept</h3>
          </div>
        </div>

        <div class="row g-3 align-items-center mb-3">
          <div class="col-auto d-block mx-auto">
            <div
              class="form-floating"
              :class="{ 'form-data-error': userNameErr }"
            >
              <input
                type="text"
                id="userNameInput"
                placeholder="Website URL (Optional)"
                class="form-control w300"
                @keyup="validateRestaurantName($event)"
                @change="validateRestaurantName($event)"
                v-model.trim="restReceiptWebsiteURL"
              />
              <label for="userNameInput"
                ><faIcons :icon="['fas', 'globe']" /> Website URL
                (Optional)</label
              >
              <small id="emailHelp" class="form-text text-muted w300"
                >Ex: https://www.website.com<br />
                Ex: www.website.com or website.com</small
              >
              <span class="error-feedback" v-if="userNameErr">
                <span class="m-2"><br />{{ userNameMsg }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="row g-3 align-items-center mb-3">
          <div class="col-auto d-block mx-auto">
            <div
              class="form-floating"
              :class="{ 'form-data-error': userAddressErr }"
            >
              <textarea
                id="userAddressInput"
                placeholder="Bottom receipt text"
                @input="validateRestaurantAddress($event)"
                class="form-control w300 h100"
                v-model.trim="restReceiptText"
              />
              <label for="userAddressInput"
                ><faIcons :icon="['fas', 'address-book']" /> Bottom receipt
                text</label
              >
              <span class="error-feedback" v-if="userAddressErr">
                {{ userAddressMsg }}
              </span>
            </div>
          </div>
        </div>
        <div class="row d-grid gap-2 w300 col-auto d-block mx-auto mb-3">
          <button
            class="btn btn-outline-success"
            @click.prevent="customRestaurantReceipt()"
            v-if="signUpBtn"
          >
            <faIcons :icon="['fas', 'file-invoice-dollar']" /> Change Settings
          </button>
        </div>
        <div class="row d-grid gap-2 w300 col-auto d-block mx-auto mb-3">
          <div class="alert alert-success" role="alert" v-if="resultSuccess">
            {{ resultSuccessMsg }}
          </div>
          <div class="alert alert-danger" role="alert" v-if="resultErr">
            {{ resultErrMsg }}
          </div>
        </div>
        <div class="row d-grid gap-2 w300 col-auto d-block mx-auto mb-3">
          <router-link
            class="btn btn-outline-primary"
            :to="{ name: 'MyRestaurants' }"
          >
            <faIcons :icon="['fas', 'undo']" /> View my restaurant(s)
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations, mapGetters } from "vuex";
import Navbar from "@/components/Header/Navbar.vue";
export default {
  name: "CustomRestaurantReceipt",
  components: {
    Navbar,
  },
  data() {
    return {
      user: {
        uId: "",
        userId: "",
        uName: "",
        uEmail: "",
        uPassword: "",
        uMemberSince: "",
        uAddress: "",
        uPhone: "",
        uRole: "",
        uRoleIs: "",
      },
      userAccessCode: "",
      restId: this.$route.params.restId,
      restNum: this.$route.params.id,
      currentRestaurantsArr: [],
      //address
      userAddress: "",
      userAddressErr: false,
      userAddressMsg: "",
      isuserAddressValidated: false,
      //phone
      userPhone: "",
      userPhoneErr: false,
      userPhoneMsg: "",
      isuserPhoneValidated: false,
      //name
      userName: "",
      userNameErr: false,
      userNameMsg: "",
      isuserNameValidated: false,

      resultSuccess: false,
      resultSuccessMsg: "",
      resultErr: false,
      resultErrMsg: "",
      image: "",
      is_DB_Connected: "",
      db_connection_msg: "",
      // apiMainUrl: "http://localhost/php/login-system-php-vue-2021/myData.php",
      apiMainUrl: this.$store.getters.MainUrl, //call global variable
      signUpBtn: true,
      restReceiptText: "",
      restReceiptWebsiteURL: "",
    };
  },
  mounted() {
    let user = localStorage.getItem("current-user-data");
    if (user) {
      let currentRestaurants = localStorage.getItem("current_restaurants_data");
      let currentRestaurant = JSON.parse(currentRestaurants).filter(
        (restInfo) =>
          restInfo.id == this.restNum && restInfo.rest_id == this.restId
      );
      let currentRestaurantReceipts = localStorage.getItem(
        "custom_restaurant_receipts"
      );
      let currentRestaurantReceipt = JSON.parse(
        currentRestaurantReceipts
      ).filter((restInfo) => restInfo.rest_id == this.restId);
      this.restReceiptText = currentRestaurantReceipt[0].bottom_text;
      this.restReceiptWebsiteURL = currentRestaurantReceipt[0].url;
      // console.log(currentRestaurants);
      this.currentRestaurantsArr = JSON.parse(currentRestaurants);
      this.userPhone = currentRestaurant[0].rest_phone;
      this.userName = currentRestaurant[0].rest_name;
      this.userAddress = currentRestaurant[0].rest_address;
      this.user.uId = JSON.parse(user).id;
      this.user.userId = JSON.parse(user).user_id;
      this.user.uName = JSON.parse(user).name;
      this.user.uEmail = JSON.parse(user).email;
      this.user.uPassword = JSON.parse(user).password;
      this.user.uMemberSince = JSON.parse(user).member_since;
      this.user.uAddress = JSON.parse(user).full_address;
      this.user.uPhone = JSON.parse(user).phone_number;
      this.user.uRole = JSON.parse(user).role;
      //if role isnt manager or admin, redirect
      if (
        JSON.parse(user).role !== "mngr" &&
        JSON.parse(user).role !== "admn"
      ) {
        this.$router.push({ name: "Login" });
      }
    } else {
      this.$router.push({ name: "Login" });
    }
  },
  computed: {
    ...mapState([
      "__RestaurantId",
      "__RestaurantEmail",
      "__RestaurantRole",
      "__RestaurantName",
      "__MainUrl",
    ]),
    ...mapGetters(["MainUrl"]),
  },
  methods: {
    ...mapMutations(["setRestaurantInfo"]),
    capitalizeFisrtLetterOfEachWord(text) {
      return text
        .toLowerCase()
        .split(" ")
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(" ");
    },
    validateRestaurantAddress(e) {
      let val = e.target.value;
      this.validateRestaurantAddressInput(val);
    },
    validateRestaurantAddressInput(val) {
      // let userAddressRegex = /^[a-zA-Z0-9 \n]+$/;
      // console.log("Is Restaurant Address Validated? " + userAddressRegex.test(val));
      console.log("Restaurant Address Is: " + val);
      if (val == "") {
        this.userAddressErr = true;
        this.isuserAddressValidated = false;
        this.userAddressMsg = "Enter bottom receipt text...";
      } else {
        this.userAddressErr = false;
        this.isuserAddressValidated = true;
        this.userAddressMsg = "";
      }
    },
    //validate Restaurant Name
    validateRestaurantPhone(e) {
      let val = e.target.value;
      this.validateRestaurantPhoneInput(val);
    },
    validateRestaurantPhoneInput(val) {
      // let userPhoneRegex = /^\d{10}$/;
      console.log("User Id: " + val);
      if (val == "") {
        this.userPhoneErr = true;
        this.isuserPhoneValidated = false;
        this.userPhoneMsg = "Enter employee/manager access code ..";
      } else {
        this.userPhoneErr = false;
        this.isuserPhoneValidated = true;
        this.userPhoneMsg = "";
      }
    },
    validateRestaurantName(e) {
      let val = e.target.value;
      this.validateRestaurantNameInput(val);
    },
    validateRestaurantNameInput(val) {
      // let userNameRegex = /^[a-zA-Z ]+$/; //allow spaces
      // let userNameRegex = /[^A-Za-z ]/g; //allow spaces, international letters
      // console.log("Is Restaurant Name Validated? " + userNameRegex.test(val));
      if (val != "") {
        //check if this url
        const isValidUrl = (urlString) => {
          var urlPattern = new RegExp(
            "^(https?:\\/\\/)?" + // validate protocol
              "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
              "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
              "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
              "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
              "(\\#[-a-z\\d_]*)?$",
            "i"
          ); // validate fragment locator
          return !!urlPattern.test(urlString);
        };
        if (isValidUrl(val) == true) {
          this.userNameErr = false;
          this.isuserNameValidated = true;
          this.userNameMsg = "";
        } else {
          this.userNameErr = true;
          this.isuserNameValidated = false;
          this.userNameMsg = "Only valid website url";
        }
      } else {
        this.userNameErr = false;
        this.isuserNameValidated = true;
        this.userNameMsg = "";
      }
    },
    async customRestaurantReceipt() {
      this.validateRestaurantNameInput(this.restReceiptWebsiteURL);
      this.validateRestaurantAddressInput(this.restReceiptText);
      if (this.isuserNameValidated && this.isuserAddressValidated) {
        this.signUpBtn = false;
        //show Result
        let fd = new FormData();
        fd.append("userId", this.user.userId);
        fd.append("role", this.user.uRole);
        fd.append("restId", this.restId);
        fd.append("text", this.restReceiptText);
        fd.append("url", this.restReceiptWebsiteURL);
        let rst = await axios.post(
          this.apiMainUrl + `?action=customRestaurantReceipt`,
          fd
        );
        console.log(rst);
        const resultData = rst.data;
        if (rst.status == 200) {
          if (resultData.error) {
            console.warn("Error Adding New User to your restaurant");
            this.resultErrMsg = resultData.message;
            this.resultErr = true;
            this.resultSuccessMsg = "";
            this.resultSuccess = false;
            this.signUpBtn = true;
          } else {
            this.signUpBtn = false;
            console.log("Good Job, new user has been added..");
            //if everything is okay
            this.resultErrMsg = "";
            this.resultErr = false;
            this.resultSuccess = true;
            //redirect only if customer
            this.resultSuccessMsg = resultData.message;
            localStorage.setItem(
              "custom_restaurant_receipts",
              JSON.stringify(resultData.custom_restaurant_receipts)
            );
            setTimeout(() => {
              this.$router.push({
                name: "AccessUsersToOnlineOrders",
                params: {
                  restId: this.restId,
                  id: this.restNum,
                },
              });
            }, 2000);
          }
        }
      } else {
        this.signUpBtn = true;
        this.validateRestaurantAddressInput(this.restReceiptText);
        this.validateRestaurantNameInput(this.restReceiptWebsiteURL);
        this.resultSuccessMsg = "";
        this.resultSuccess = false;

        this.resultErrMsg = "Must enter all required information";
        this.resultErr = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$navColor: #3f51b6;
nav a {
  text-decoration: none;
  color: $navColor;
  font-weight: bold;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
